// index_tracking_links_page.js

import TrackingLinksUtils from './tracking_links_utils';

document.addEventListener('alpine:init', () => {
    Alpine.data('prefix_tracking_links_index_x_data', () => {
        // Get data from the template tag
        const template = document.getElementById('prefix-tracking-links-index-data');
        const distribution_links = JSON.parse(template.dataset.distributionLinks);
        const all_distribution_platforms = JSON.parse(template.dataset.allDistributionPlatforms);
        const authenticity_token = template.dataset.authenticityToken;
        const batch_update_url = template.dataset.batchUpdateUrl;
        const continue_url = template.dataset.continueUrl;
        const duplicate_url = template.dataset.duplicateUrl;
        const delete_url = template.dataset.deleteUrl;
        const refresh_url = template.dataset.refreshUrl;

        // Initialize data using shared utilities
        const data = TrackingLinksUtils.createInitialData();
        Object.assign(data, {
            distribution_links: distribution_links,
            all_distribution_platforms: all_distribution_platforms,
            selected_youtube_url: false, // Responsible for the note that shows up when youtube videos are selected
            redirect_only: false // Controls the text shown on the "Add more" button
        });

        return {
            ...data,
            // Duplicate tracking link properties
            all_source_data: [],
            show_duplicate_modal: false,
            link_name: '',
            selected_source: '',
            tracking_source_id: '',
            selected_tracking_source_id: '',
            tracking_link_id: '',
            has_source_error: false,
            source_error_message: '',
            has_link_name_error: false,
            link_name_error_message: '',
            create_button_text: 'Create Link',
            init() {
                this.create_arrays();
                let that = this;
                // Listen for changes to the array and update selected_youtube_url
                this.$watch('distribution_links_truth', (newValue) => {
                    that.selected_youtube_url = newValue.some(link => link.pattern === 'youtube_url');
                });
            },
            create_arrays() {
                TrackingLinksUtils.createArrays(this, this.distribution_links, this.all_distribution_platforms);
                this.build_options_list();
                if (this.distribution_links_truth.length > 0) {
                    this.create_link_elements();
                } else {
                    this.create_empty_link_elements();
                }
            },
            create_link_elements() {
                const linksContainer = document.querySelector("#links-container");
                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    const link = this.distribution_links_truth[i];
                    if (link.url !== "") {
                        if (link.name === "Custom") {
                            linksContainer.innerHTML += `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="flex space-x-2 w-full">
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-title" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Enter the name to be displayed" value="${link.title}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                            <div class="relative rounded-md shadow-sm w-full">
                                <input @keyup="$event.target.value !== '' && validate_link('${link.pattern}', $event.target.value, false) === true ? $event.target.nextElementSibling.classList.remove('hidden') : $event.target.nextElementSibling.classList.add('hidden')" id="${link.pattern}-url" type="text" class="block pr-10 h-9 w-full rounded border-gray-300 text-sm" placeholder="Copy and paste your custom link" value="${link.url}">
                                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                  </svg>
                                </div>
                            </div>
                        </div>

                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              `;
                        } else {
                            linksContainer.innerHTML += `
                        <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                          <div class="flex space-x-4 items-center">
                            <div class="w-12 h-12">
                              <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                            </div>
                            <div class="flex flex-col flex-1 space-y-2">
                              <div class="font-bold text-sm">${link.name}</div>
                              <div class="flex space-x-2 items-center">
                                <div class="relative rounded-md shadow-sm w-full"
                                          x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}', false) }"
                                          x-init="$watch('url', value => {
                                              if (value === '') {
                                                is_valid = null
                                              } else {
                                                is_valid = validate_link('${link.pattern}', value, false)
                                              }
                                          })"
                                >
                                    <input
                                    x-model="url"
                                    id="${link.pattern}-url"
                                    autocomplete="off"
                                    type="text"
                                    class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                                    placeholder="Copy and paste your ${link.name} link" value="${link.url}">
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
                                    </div>
                                    <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                                    x-show="is_valid === false">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                                        <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      `;
                        }
                    }
                }
            },
            create_empty_link_elements() {
                let that = this;
                const linksContainer = document.querySelector("#links-container");
                const default_items = [{ name: "Apple Podcasts", pattern: "itunes_url", url: "" }, {
                    name: "Spotify",
                    pattern: "spotify_url",
                    url: ""
                }, { name: "YouTube Music", pattern: "youtube_music_url", url: "" }];
                for (let i = 0; i < default_items.length; i++) {
                    const link = default_items[i];
                    that.distribution_links_truth.push({
                        name: link.name,
                        pattern: link.pattern,
                        url: ""
                    });
                    linksContainer.innerHTML += `
<div id="${link.pattern}" class="border rounded p-4 ql-link-el">
  <div class="flex space-x-4 items-center">
    <div class="w-12 h-12">
      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
    </div>
    <div class="flex flex-col flex-1 space-y-2">
      <div class="font-bold text-sm">${link.name}</div>
      <div class="flex space-x-2 items-center">
        <div class="relative rounded-md shadow-sm w-full"
             x-data="{ url: '', is_valid: null }"
             x-init="$watch('url', value => {
               is_valid = value === '' ? null : validate_link('${link.pattern}', value, false)
             })"
        >
          <input
            x-model="url"
            id="${link.pattern}-url"
            autocomplete="off"
            type="text"
            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
            placeholder="Copy and paste your ${link.name} link"
          >

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === true">
                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                                      </svg>
          </div>

          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
               x-show="is_valid === false">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')"
             width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</div>
`;
                    that.remove_from_options_list(link.pattern);
                }
            },
            delete_link(name, pattern) {
                TrackingLinksUtils.deleteLink(this, name, pattern);
            },
            add_to_options_list(name, pattern) {
                TrackingLinksUtils.addToOptionsList(this.add_more_options, name, pattern);
                this.build_options_list();
            },
            remove_from_options_list(pattern) {
                TrackingLinksUtils.removeFromOptionsList(this.add_more_options, pattern);
                this.build_options_list();
            },
            build_options_list() {
                TrackingLinksUtils.buildOptionsList(this.add_more_options);
                this.sync_options();
            },
            handle_add_more() {
                TrackingLinksUtils.handleAddMore(this);
            },
            sync_options() {
                TrackingLinksUtils.syncOptions(this.selectorVisible, this.distributionLinkSelector);
            },
            create_link_element(value, item) {
                TrackingLinksUtils.createLinkElement(value, item, this);
            },
            submit() {
                const linkElements = document.querySelectorAll(".ql-link-el");
                let data = {};
                for (let i = 0; i < linkElements.length; i++) {
                    const linkElement = linkElements[i];
                    const pattern = linkElement.id;
                    const url = document.querySelector(`#${pattern}-url`).value;
                    data[pattern] = url;
                    if (this.validate_link(pattern, url, true) === false) {
                        alert('Please fix the issues with the links before submitting.');
                        return;
                    }
                }

                if (Object.keys(data).length === 0 || this.check_if_all_empty(data)) {
                    this.error_text = "Please enter at least one show link.";
                } else {
                    for (let i = 0; i < this.existing_links_to_delete.length; i++) {
                        if (data.hasOwnProperty(this.existing_links_to_delete[i]) === false) {
                            data[this.existing_links_to_delete[i]] = "";
                        }
                    }
                    fetch(batch_update_url, {
                        headers: {
                            "Content-Type": "application/json"
                        },
                        method: "POST",
                        body: JSON.stringify({
                            authenticity_token: authenticity_token,
                            distribution_links: data
                        })
                    }).then(response => response.json())
                        .then(data => {
                            window.location.href = continue_url;
                        });
                }
            },
            check_if_all_empty(obj) {
                let allEmpty = true;
                for (let key in obj) {
                    if (obj[key] !== "") {
                        allEmpty = false;
                    }
                }
                return allEmpty;
            },
            validate_link(pattern, url, set_message) {
                const result = window.validate_link(pattern, url);
                if (set_message && !result) {
                    this.set_error_message(pattern);
                }
                return result;
            },
            set_error_message(pattern) {
                this.error_text = TrackingLinksUtils.setErrorMessage(this.all_distribution_platforms, pattern);
            },
            clear_error_message() {
                TrackingLinksUtils.clearErrorMessage(this);
            },
            duplicate_tracking_link_init() {
                let that = this;
                const source_list = that.$refs.frontend_data.dataset.sourceList;
                that.all_source_data = JSON.parse(source_list);
            },
            open_duplicate_tracking_link_modal(tracking_link_id, source_name) {
                this.show_duplicate_modal = true;
                this.tracking_link_id = tracking_link_id;
                this.tracking_source_id = this.all_source_data.find(source => source.source === source_name).id;
            },
            close_duplicate_tracking_link_modal() {
                this.show_duplicate_modal = false;
                this.tracking_link_id = '';
                this.selected_source = '';
                this.tracking_source_id = '';
                this.selected_source_id = '';
                this.selected_tracking_source_id = '';
                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                this.link_name = '';
                this.create_button_text = 'Create Link';
            },
            validate_submit_duplicate_link() {
                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                if (this.selected_tracking_source_id === '') {
                    this.has_source_error = true;
                    this.source_error_message = 'Please select a source';
                }
                if (this.link_name.trim() === '') {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Please enter a link name';
                }
                if (this.link_name.length > 30) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name should be less than 30 characters';
                }
                if (this.link_name.length > 0 && this.link_name.length <= 2) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name should have more than 2 characters';
                }
                if (this.selected_tracking_source_id === this.tracking_source_id) {
                    this.has_source_error = true;
                    this.source_error_message = 'Please select a different source than the link you are duplicating.';
                }
                const regex = /^[a-zA-Z0-9 _\-$&''\u2018\u2019().,;:!?\u2013\u2014]+$/;
                if (!regex.test(this.link_name)) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name contains unsupported characters.';
                }
                if (this.has_source_error || this.has_link_name_error) {
                    return false;
                } else {
                    this.submit_duplicate_link_data();
                }
            },
            submit_duplicate_link_data() {
                let that = this;
                let duplicate_link_url = duplicate_url;
                const replace_id = that.tracking_link_id;
                duplicate_link_url = duplicate_link_url.replace(':replace_id', replace_id);
                that.create_button_text = 'Creating link ...';
                fetch(duplicate_link_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: authenticity_token,
                        tracking_link_id: that.tracking_link_id,
                        tracking_source_id: that.selected_tracking_source_id,
                        link_name: that.link_name
                    })
                }).then(function (res) {
                    setTimeout(function () {
                        sessionStorage.setItem('flash_message', JSON.stringify(['notice', 'Your tracking link(s) have been created!']));
                        document.location.href = delete_url;
                    }, 250);
                });
            }
        };
    });

    // Tracking link library data
    Alpine.data('tracking_link_library_data', () => {
        return {
            // Duplicate tracking link modal state
            all_source_data: [],
            show_duplicate_modal: false,
            link_name: '',
            selected_source: '',
            tracking_source_id: '',
            selected_tracking_source_id: '',
            tracking_link_id: '',
            has_source_error: false,
            source_error_message: '',
            has_link_name_error: false,
            link_name_error_message: '',
            create_button_text: 'Create Link',
            // URLs and tokens
            duplicate_url: '',
            authenticity_token: '',
            delete_url: '',
            // Menu properties
            prevClickedMenu: undefined,
            subMenuOpen: false,
            show_delete_modal: false,
            delete_button_text: 'Delete Link',
            delete_text: "",
            clickedOutside: 0,
            init() {
                // Initialize duplicate tracking link functionality
                let that = this;
                const source_list = that.$refs.frontend_data.dataset.sourceList;
                that.all_source_data = JSON.parse(source_list);
                // Read URLs and tokens from template tag
                const template = document.getElementById('prefix-tracking-links-index-data');
                this.duplicate_url = template.dataset.duplicateUrl;
                this.authenticity_token = template.dataset.authenticityToken;
                this.delete_url = template.dataset.deleteUrl;
            },
            open_duplicate_tracking_link_modal(tracking_link_id, source_name) {
                this.show_duplicate_modal = true;
                this.tracking_link_id = tracking_link_id;
                this.tracking_source_id = this.all_source_data.find(source => source.source === source_name).id;
            },
            close_duplicate_tracking_link_modal() {
                this.show_duplicate_modal = false;
                this.tracking_link_id = '';
                this.selected_source = '';
                this.tracking_source_id = '';
                this.selected_source_id = '';
                this.selected_tracking_source_id = '';
                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                this.link_name = '';
                this.create_button_text = 'Create Link';
            },
            validate_submit_duplicate_link() {
                this.has_source_error = false;
                this.source_error_message = '';
                this.has_link_name_error = false;
                this.link_name_error_message = '';
                if (this.selected_tracking_source_id === '') {
                    this.has_source_error = true;
                    this.source_error_message = 'Please select a source';
                }
                if (this.link_name.trim() === '') {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Please enter a link name';
                }
                if (this.link_name.length > 30) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name should be less than 30 characters';
                }
                if (this.link_name.length > 0 && this.link_name.length <= 2) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name should have more than 2 characters';
                }
                if (this.selected_tracking_source_id === this.tracking_source_id) {
                    this.has_source_error = true;
                    this.source_error_message = 'Please select a different source than the link you are duplicating.';
                }
                const regex = /^[a-zA-Z0-9 _\-$&''\u2018\u2019().,;:!?\u2013\u2014]+$/;
                if (!regex.test(this.link_name)) {
                    this.has_link_name_error = true;
                    this.link_name_error_message = 'Link name contains unsupported characters.';
                }
                if (this.has_source_error || this.has_link_name_error) {
                    return false;
                } else {
                    this.submit_duplicate_link_data();
                }
            },
            submit_duplicate_link_data() {
                let that = this;
                let duplicate_link_url = this.duplicate_url;
                const replace_id = this.tracking_link_id;
                duplicate_link_url = duplicate_link_url.replace(':replace_id', replace_id);
                this.create_button_text = 'Creating link ...';
                fetch(duplicate_link_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: this.authenticity_token,
                        tracking_link_id: this.tracking_link_id,
                        tracking_source_id: this.selected_tracking_source_id,
                        link_name: this.link_name
                    })
                }).then(function (res) {
                    setTimeout(function () {
                        sessionStorage.setItem('flash_message', JSON.stringify(['notice', 'Your tracking link(s) have been created!']));
                        document.location.href = that.delete_url;
                    }, 250);
                });
            },
            open_sub_menu(event) {
                this.subMenuOpen = true;
                this.clickedOutside = 0;
                const menu = event.currentTarget.nextElementSibling;
                if (this.prevClickedMenu && this.prevClickedMenu != menu) {
                    this.prevClickedMenu.classList.add("hidden");
                }
                this.prevClickedMenu = menu;
                if (menu.classList.contains("hidden")) {
                    menu.classList.remove("hidden");
                } else {
                    menu.classList.add("hidden");
                    this.subMenuOpen = false;
                }
            },
            close_sub_menu() {
                if (this.subMenuOpen && this.clickedOutside === 2) {
                    this.prevClickedMenu.classList.add("hidden");
                    this.subMenuOpen = false;
                }
            },
            open_delete_modal(id, link_name) {
                this.delete_text = `You are deleting the link ${link_name}.`;
                this.show_delete_modal = true;
                this.prevClickedMenu.classList.add("hidden");
                this.tracking_link_id = id;
            },
            delete_tracking_link() {
                let that = this;
                that.delete_button_text = 'Deleting link ...';
                fetch(`${this.delete_url}/${this.tracking_link_id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: this.authenticity_token
                    })
                }).then(function (res) {
                    that.delete_button_text = 'Link deleted. Reloading page...';
                    setTimeout(function () {
                        document.location.href = that.delete_url;
                    }, 250);
                });
            }
        };
    });

    // Refresh feed data
    Alpine.data('refreshFeedData', () => {
        return {
            refreshing: false,
            refresh_button_text: 'Refresh Feed',
            refresh_url: '',
            authenticity_token: '',
            refresh_steps: [
                ['Fetching latest data...', 8],
                ['Updating episode data...', parseInt(Math.random() * 4) + 3],
                ['Updating tracking links...', parseInt(Math.random() * 4) + 3],
                ['Putting final touches...', 3],
                ['Refresh complete!', 2]
            ],
            init() {
                // Read URLs and tokens from template tag
                const template = document.getElementById('prefix-tracking-links-index-data');
                this.refresh_url = template.dataset.refreshUrl;
                this.authenticity_token = template.dataset.authenticityToken;
            },
            refreshFeed() {
                this.refreshing = true;
                this.refreshing_state(0);
                setTimeout(() => {
                    this.refreshing = false;
                }, 2000);
                fetch(this.refresh_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: this.authenticity_token
                    })
                }).then(function (res) {
                    console.log("Refreshed feed");
                }).catch(function (err) {
                    console.error("Error refreshing feed:", err);
                });
            },
            refreshing_state(i) {
                if (i < this.refresh_steps.length) {
                    this.refresh_button_text = this.refresh_steps[i][0];
                    setTimeout(() => {
                        this.refreshing_state(i + 1);
                    }, this.refresh_steps[i][1] * 100);
                }
            }
        };
    });
});

// Copy to clipboard functionality
window.copyToClipboard = function (text) {
    const notification = document.querySelector("#copied-to-clipboard-notification");
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () {
            console.log("Copied successfully");
            notification.classList.remove("hidden");
            setTimeout(function () {
                notification.classList.add("hidden");
            }, 3000);
        }, function (err) {
            console.error("Could not copy text:", err);
        });
    } else {
        // Fallback for insecure contexts
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";  // prevent scrolling to bottom of page
        textarea.style.top = "-1000px";
        textarea.style.left = "-1000px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            document.execCommand('copy');
            console.log("Copied with fallback");
            notification.classList.remove("hidden");
            setTimeout(function () {
                notification.classList.add("hidden");
            }, 3000);
        } catch (err) {
            console.error("Fallback copy failed:", err);
        }
        document.body.removeChild(textarea);
    }
}; 